import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic, AppState } from 'src/store';
import { of } from 'rxjs';
import {
  inputIsNotNullOrUndefined,
  isScopeDefined,
  isWorklistActive,
  maybeGetComponentProps,
  topMemInUrl,
} from 'src/utils/Functions/epicsFunctions';
import { get, isEmpty } from 'lodash';
import { ConfDefnComponentType, EditableOverTimeGridComponent } from 'configuration-schemas/confdefnComponents';

import {
  fetchOverTimeData,
  updateSelectedItem,
  refreshOvertimeData,
  fetchCompanionData,
} from 'src/pages/AssortmentBuild/Pricing/PricingOverTime.slice';
import { receiveScopeRefreshTrigger } from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { fetchMassEditData } from 'src/pages/AssortmentBuild/Pricing/PricingOverTime.slice';
import { LENS_ASST_PLAN_REFRESHING_PAGE } from '../Planning.types';

function fetchTopMember(state: AppState, worklistSelectedItem?: string): string {
  const flowSheetSelectedItem = !isEmpty(state.pages.assortmentBuild.pricing.selectedItem)
    ? state.pages.assortmentBuild.pricing.selectedItem
    : null;
  const worklistItem = worklistSelectedItem;
  const urlTopMember = topMemInUrl();
  return flowSheetSelectedItem ?? worklistItem ?? urlTopMember ?? '';
}

export const pricingOverTimeLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(updateSelectedItem.type, refreshOvertimeData.type),
    filter((action) => {
      if (action.type === updateSelectedItem.type && isEmpty(action.payload)) {
        return false;
      }
      return true;
    }),
    map(() => maybeGetComponentProps<EditableOverTimeGridComponent>(state$.value, ConfDefnComponentType.pricing)),
    filter(inputIsNotNullOrUndefined),
    filter(() => isScopeDefined(state$.value.scope)),
    mergeMap((componentProps) => {
      const { topMembers } = componentProps;
      const currentSelectedItem = fetchTopMember(state$.value, topMembers);
      // we allow a third element to be passed in from `componentProps.defns.models` in flowsheet/pricing,
      // to override the modeldefn, in order to support different pivot runs
      const maybeThirdModel = get(componentProps.defns.models, '2', undefined);

      if (!isEmpty(currentSelectedItem)) {
        return of(fetchOverTimeData(currentSelectedItem, maybeThirdModel));
      }

      return of();
    }),
  );
};

export const pricingOvertimeCompanionLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(receiveScopeRefreshTrigger.type, LENS_ASST_PLAN_REFRESHING_PAGE, receiveFilterStateAfterSubmission.type),
    map(() => maybeGetComponentProps<EditableOverTimeGridComponent>(state$.value, ConfDefnComponentType.pricing)),
    filter(inputIsNotNullOrUndefined),
    filter(() => !isWorklistActive(state$.value)),
    filter(() => isScopeDefined(state$.value.scope)),
    mergeMap(({ defns }) => {
      const hideCompanion = maybeGetComponentProps<EditableOverTimeGridComponent>(
        state$.value,
        ConfDefnComponentType.pricing,
      )?.hideCompanion;

      if (hideCompanion === true) {
        return of(updateSelectedItem(''));
      }
      // On scope change we need to update companion data && mass edit data
      const companionModel = defns.models[0];
      const massEditModel = defns.models[1];

      const actions = [
        updateSelectedItem(''),
        ...(companionModel ? [fetchCompanionData(companionModel)] : []),
        ...(massEditModel ? [fetchMassEditData(massEditModel)] : []),
      ];

      return of(...actions);
    }),
  );
};
